import { MULTIPLE_SELECT_EMPTY } from 'ACTIONS';

export const emptyMSelect = () => (
    {
        type: MULTIPLE_SELECT_EMPTY
    }
);
